import { takeLatest } from 'redux-saga/effects'

import Actions from 'redux/actions'
import {
  getSpecialServicesList as getSpecialServicesListAction,
  getGovernmentAgencies as getGovernmentAgenciesAction,
  getConsultancyTypes as getConsultancyTypesAction,
  createGovernmentRequest as createGovernmentRequestAction,
  createConsultancyRequest as createConsultancyRequestAction,
  createDomesticRequest as createDomesticRequestAction,
  uploadFile as uploadFileAction,
  getSpecialServiceRequest as getSpecialServiceRequestAction,
} from 'redux/actionCreators/premiumUserAPI/specialServices'
import specialServicesAPI from 'api/premiumUserAPI/specialServicesAPI'

import { getSimpleRequestHandler } from '../../utils'

const getSpecialServicesList = getSimpleRequestHandler<
  typeof specialServicesAPI.getSpecialServicesList,
  ReturnType<typeof getSpecialServicesListAction>
>({
  actionLoading: Actions.GET_SPECIAL_SERVICES_LIST_ASYNC,
  actionSuccess: Actions.GET_SPECIAL_SERVICES_LIST_SUCCESS,
  actionFail: Actions.GET_SPECIAL_SERVICES_LIST_FAIL,
  callApiFn: specialServicesAPI.getSpecialServicesList,
})

const getGovernmentAgencies = getSimpleRequestHandler<
  typeof specialServicesAPI.getGovernmentAgencies,
  ReturnType<typeof getGovernmentAgenciesAction>
>({
  actionLoading: Actions.GET_GOVERNMENT_AGENCIES_ASYNC,
  actionSuccess: Actions.GET_GOVERNMENT_AGENCIES_SUCCESS,
  actionFail: Actions.GET_GOVERNMENT_AGENCIES_FAIL,
  callApiFn: specialServicesAPI.getGovernmentAgencies,
})

const getConsultancyTypes = getSimpleRequestHandler<
  typeof specialServicesAPI.getConsultancyTypes,
  ReturnType<typeof getConsultancyTypesAction>
>({
  actionLoading: Actions.GET_CONSULTANCY_TYPES_ASYNC,
  actionSuccess: Actions.GET_CONSULTANCY_TYPES_SUCCESS,
  actionFail: Actions.GET_CONSULTANCY_TYPES_FAIL,
  callApiFn: specialServicesAPI.getConsultancyTypes,
})

const createGovernmentRequest = getSimpleRequestHandler<
  typeof specialServicesAPI.createGovernmentRequest,
  ReturnType<typeof createGovernmentRequestAction>
>({
  actionLoading: Actions.CREATE_GOVERNMENT_REQUEST_ASYNC,
  actionSuccess: Actions.CREATE_GOVERNMENT_REQUEST_SUCCESS,
  actionFail: Actions.CREATE_GOVERNMENT_REQUEST_FAIL,
  callApiFn: specialServicesAPI.createGovernmentRequest,
})

const createConsultancyRequest = getSimpleRequestHandler<
  typeof specialServicesAPI.createConsultancyRequest,
  ReturnType<typeof createConsultancyRequestAction>
>({
  actionLoading: Actions.CREATE_CONSULTANCY_REQUEST_ASYNC,
  actionSuccess: Actions.CREATE_CONSULTANCY_REQUEST_SUCCESS,
  actionFail: Actions.CREATE_CONSULTANCY_REQUEST_FAIL,
  callApiFn: specialServicesAPI.createConsultancyRequest,
})

const createDomesticRequest = getSimpleRequestHandler<
  typeof specialServicesAPI.createDomesticRequest,
  ReturnType<typeof createDomesticRequestAction>
>({
  actionLoading: Actions.CREATE_DOMESTIC_REQUEST_ASYNC,
  actionSuccess: Actions.CREATE_DOMESTIC_REQUEST_SUCCESS,
  actionFail: Actions.CREATE_DOMESTIC_REQUEST_FAIL,
  callApiFn: specialServicesAPI.createDomesticRequest,
})

const uploadFile = getSimpleRequestHandler<typeof specialServicesAPI.uploadFile, ReturnType<typeof uploadFileAction>>({
  actionLoading: Actions.UPLOAD_SPECIAL_SERVICE_FILE_ASYNC,
  actionSuccess: Actions.UPLOAD_SPECIAL_SERVICE_FILE_SUCCESS,
  actionFail: Actions.UPLOAD_SPECIAL_SERVICE_FILE_FAIL,
  callApiFn: specialServicesAPI.uploadFile,
})

const getSpecialServiceRequest = getSimpleRequestHandler<
  typeof specialServicesAPI.getSpecialServiceRequest,
  ReturnType<typeof getSpecialServiceRequestAction>
>({
  actionLoading: Actions.GET_SPECIAL_SERVICE_DETAILS_ASYNC,
  actionSuccess: Actions.GET_SPECIAL_SERVICE_DETAILS_SUCCESS,
  actionFail: Actions.GET_SPECIAL_SERVICE_DETAILS_FAIL,
  callApiFn: specialServicesAPI.getSpecialServiceRequest,
})

export default [
  takeLatest(Actions.GET_SPECIAL_SERVICES_LIST, getSpecialServicesList),
  takeLatest(Actions.GET_GOVERNMENT_AGENCIES, getGovernmentAgencies),
  takeLatest(Actions.GET_CONSULTANCY_TYPES, getConsultancyTypes),
  takeLatest(Actions.CREATE_GOVERNMENT_REQUEST, createGovernmentRequest),
  takeLatest(Actions.CREATE_CONSULTANCY_REQUEST, createConsultancyRequest),
  takeLatest(Actions.CREATE_DOMESTIC_REQUEST, createDomesticRequest),
  takeLatest(Actions.UPLOAD_SPECIAL_SERVICE_FILE, uploadFile),
  takeLatest(Actions.GET_SPECIAL_SERVICE_DETAILS, getSpecialServiceRequest),
]
